import {
  prop,
  compose,
  identity,
  converge,
  flip,
  pair,
  map,
  fromPairs,
} from 'ramda';

import { LOCALE_MAP } from 'app/features/localization/constants';

const getLocalization = prop('localization');
const translations = compose(prop('translations'), getLocalization);

const translationForKey = translationKey =>
  compose(prop(translationKey), translations);

const getLocales = compose(prop('locales'), getLocalization);
const getLocaleMap = compose(
  fromPairs,
  map(converge(pair, [identity, flip(prop)(LOCALE_MAP)])),
  getLocales,
);

export { translations, translationForKey, getLocales, getLocaleMap };
